import { Link } from "react-router-dom";
import Footer from "../components/footer";

export default function Comparison () {
    return(
        <div  class="w-full sm:w-1/3 btwo">
            <div class="w-full mt-8 flex flex-row justify-around">
               <div class="text-4xl w-5/12">
                   <p>horsey</p>
               </div>
               <Link class="w-3/12 rounded pt-1 h-8 bg-blue-700" to="/beforeSignUp">
               <div class="w-full text-white text-center font-light">
                   <p>Sign In</p>
               </div>
               </Link>
           </div>

           <div class="w-full mb-4 flex">
            <div class="w-4/12"></div>
            <div class="w-3/12">
                <p>beta</p>
            </div>
           </div>
           <div class="w-full h-4"/>
            <div class="text-white p-3 flex flex-col gap-4 bg-pink-600">
            <div class="text-center flex flex-col gap-3 ctwo">
            <div>Idea Resume</div>
            <div class="btwo">and</div>
            <div>Traditional Resume</div>
            </div>
            <div class="bg-pink-400 text-black text-center">
            <div class="font-bold text-center bg-white w-full py-2 ">Nature of Resume</div>
            <div class="py-4">
            <div class=" text-[16px] w-full text-center text-blue-800  ">In an Idea Resume</div>
            <div class="">Understanding the Problem</div>
            </div>
            <div class=" pb-4"><div class=" text-[12px] w-full text-center text-white   ">In a Normal Resume</div><div class="">Understanding the Objective</div></div>
            </div>
            <div class="bg-pink-400 text-black text-center">
            <div class="font-bold text-center bg-white w-full py-2  ">Judged on the basis of</div>
            <div class=" "><div class=" text-[12px] w-full text-center text-white   ">In an Idea Resume</div><div class=" ">Clarity of vision in seeing reality</div></div>
            <div class=" "><div class=" text-[12px] w-full text-center text-white   ">In a Normal Resume</div><div class=" ">Showcase of achievements</div></div>
            </div>
            <div class="bg-pink-400 text-black text-center">
            <div class="font-bold text-center bg-white w-full py-2  ">You study and enhance</div>
            <div class=" "><div class=" text-[12px] w-full text-center text-white   " >In an Idea Resume</div><div class=" ">Analytical Capability</div></div>
            <div class=" "><div class=" text-[12px] w-full text-center text-white   ">In a Normal Resume</div><div class="">Conceptual Discernment</div></div>
            </div>
            <div class="bg-pink-400 text-black text-center">
            <div class="font-bold text-center bg-white w-full py-2 ">Goal</div>
            <div class=" "><div class=" text-[12px] w-full text-center text-white   ">In an Idea Resume</div><div class=" ">Ability to be practical</div></div>
            <div class=" "><div class=" text-[12px] w-full text-center text-white   ">In a Normal Resume</div><div class="">Personality Building</div></div>
            </div>
            <div class="bg-pink-400 text-black text-center">
            <div class="font-bold text-center bg-white w-full py-2 ">Hidden skill obtained</div>
            <div class=" "><div class=" text-[12px] w-full text-center text-white   ">In an Idea Resume</div><div class="">Identification of pivotal events</div></div>
            <div class=" " ><div class=" text-[12px] w-full text-center text-white   ">In a Normal Resume</div><div class="">Identification of optimizations</div></div>
            </div>
            <div class="bg-pink-400 text-black text-center">
            <div class="font-bold text-center bg-white w-full py-2 ">Teaches you</div>
            <div class=" "><div class=" text-[12px] w-full text-center text-white   ">In an Idea Resume</div><div class="">To be different</div></div>
            <div class=" "><div class=" text-[12px] w-full text-center text-white   ">In a Normal Resume</div><div class="">To outperform</div></div>
            </div>
            <div class=" flex flex-row text-black justify-evenly">
                <div class="px-4 py-2 rounded bg-yellow-100">1</div>
                <div class="px-4 py-2 rounded bg-yellow-100">2</div>
                <div class="px-4 py-2 rounded bg-yellow-100">12</div>
            </div>
            <div>
            <div class="text-center mb-1">and many more..</div>
            <div class="text-center">You Need Both</div>
            </div>
            </div>
            <Footer/>
        </div>
    );
}